import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'

export const CustomLink = ({
  children,
  to,
  keepQueryStrParams,
  inActive,
  ...others
}) => {
  const location = useLocation()

  const result = []
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  keepQueryStrParams.forEach((paramKey) => {
    result.push(paramKey + '=' + params[paramKey])
  })

  return to && !inActive ? (
    <Link
      to={result.length ? [to, result.join('&')].join('?') : to}
      {...others}
    >
      {children}
    </Link>
  ) : (
    <div {...others}>{children}</div>
  )
}

CustomLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  keepQueryStrParams: PropTypes.arrayOf(PropTypes.string),
  inActive: PropTypes.bool,
}

CustomLink.defaultProps = {
  keepQueryStrParams: [],
}
